// import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastProvider } from 'src/design-system';
import * as Sentry from '@sentry/react';

import './index.css';
import './utils/analytics';
import App from './App';
import { Auth0ProviderWithNavigate } from './providers/auth0ProviderWithNavigate';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { store } from './store';
import { installChunkLoadErrorReload } from './utils/reloadOnChunkLoadError';
import { validateEnv } from './utils/validateEnv';

validateEnv();

installChunkLoadErrorReload();

if (import.meta.env.VITE_SENTRY_DSN) {
  // const apiUrl = import.meta.env.VITE_API_SERVER_URL;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    // this breaks CORS
    // tracePropagationTargets: [
    //   'localhost',
    //   ...(apiUrl ? [new RegExp(`^${apiUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`)] : [])
    // ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true
  });
}

createRoot(document.getElementById('root')!).render(
  <Router>
    <Auth0ProviderWithNavigate>
      <Provider store={store}>
        {/* <StrictMode> */}
        <ToastProvider />
        <WebSocketProvider>
          <App />
        </WebSocketProvider>
        {/* </StrictMode> */}
      </Provider>
    </Auth0ProviderWithNavigate>
  </Router>
);
